import { atom, AtomEffect } from "recoil";

import { User } from "types/types";

const persistAtom =
  <T>(key: string): AtomEffect<T> =>
  ({ setSelf, onSet, resetSelf }) => {
    // On load, if there's a value in localStorage, set the atom
    const savedValue = localStorage.getItem(key);
    if (savedValue != null) {
      setSelf(JSON.parse(savedValue));
    }

    // Subscribe to changes in the atom and update localStorage
    onSet((newValue, _, isReset) => {
      isReset
        ? localStorage.removeItem(key)
        : localStorage.setItem(key, JSON.stringify(newValue));
    });

    // When the value changes in localstorage (from another tab), update the atom
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === key) {
        if (event.newValue === null) {
          resetSelf();
        } else {
          const newValue = JSON.parse(event.newValue);
          setSelf(newValue);
        }
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  };

export const userState = atom<User | null>({
  key: "user",
  default: null,
  effects: [persistAtom("user")],
});

export const tokenState = atom<string | null>({
  key: "token",
  default: null,
  effects: [persistAtom("token")],
});

export const loadingState = atom({
  key: "loading",
  default: false,
});

export const previousUrlState = atom({
  key: "previousUrl",
  default: "",
});
